import React from 'react';
import { useTranslation } from 'react-i18next';
import "./resume.css";
import Data from './Data';
import Card from './Card';

const Resume = () => {
  const { t } = useTranslation();
  const data = Data();

  return (
    <section className="resume container section" id="resume">
      <h2 className="section__title">{t('resume')}</h2>

      <div className="resume__container grid">
          <div className="timeline grid">
            <h3 className="timeline__heading">{t('education') ? t('education').charAt(0).toUpperCase() + t('education').slice(1) : 'Education'}</h3>
            {data.map((val, id) => {
              if (val.category === "education") {
                return (
                  <Card
                    key={id}
                    icon={val.icon}
                    title={val.title}
                    year={val.year}
                    desc={val.desc}
                  />
                );
              }
              return null; // Ensure a value is returned
            })}
          </div>

          <div className="timeline grid">
            <h3 className="timeline__heading">{t('experience') ? t('experience').charAt(0).toUpperCase() + t('experience').slice(1) : 'Experience'}</h3>
            {data.map((val, index) => {
              if (val.category === "experience") {
                return (
                  <Card
                    key={index}
                    icon={val.icon}
                    title={val.title}
                    year={val.year}
                    desc={val.desc}
                  />
                );
              }
              return null; // Ensure a value is returned
            })}
          </div>
      </div>
    </section>
  );
}

export default Resume;